import { ColorRepresentation } from 'three';

export const colorArtSelected: ColorRepresentation = 0xff0000;
export const colorArtNotSelected: ColorRepresentation = 0xffffff;
